import { render, staticRenderFns } from "./OnboardingSeller.vue?vue&type=template&id=7a7a2a6e&scoped=true"
import script from "./OnboardingSeller.vue?vue&type=script&lang=js"
export * from "./OnboardingSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7a2a6e",
  null
  
)

export default component.exports